import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";
import { FcInspection, FcKindle, FcCalendar } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const SubmenuTahfidzPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Tahfidz",
    });
  }, [setHeader]);
  return (
    <div className="tw-p-4 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div onClick={() => navigate("/school/tahfidz")} className="tw-m-0">
            <FcKindle className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Laporan Tahfidz</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate("/school/tahfidz-rekap")}
            className="tw-m-0"
          >
            <FcInspection
              className="card-icon"
              style={{ background: "#eee" }}
            />
            <div className="tw-mt-0 card-name">Rekap Tahfidz</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate("/school/tahfidz-absence")}
            className="tw-m-0"
          >
            <FcCalendar className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Absensi Tahfidz</div>
          </div>
        </div>
      </div>
    </div>
  );
};
